import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../../config/site.json';
import ButtonGroup from '../../molecules/ButtonGroup';
import StagIcon from '../../atoms/Icon/Stag';
import TuxIcon from '../../atoms/Icon/Tux';
import './Person.css';

class Person extends Component {

  render() {

    const {personId, name, role, peopleWithPoints, adminVisible} = this.props;

    const handlePointsChange = (val) => {
      this.props.addPointsChange(personId, val);
    };

    const pointsOptions = [
      -config.points.big,
      -config.points.small,
      +config.points.small,
      +config.points.big,
    ];

    const iconProps = {
      width: "24px",
      height: "24px",
      fill: "#FFF",
    };

    return (

      <div className="Person">
        <span className="Person-name">
          {role === "stag" && (
            <StagIcon {...iconProps} title="Stag" />
          )}
          {role === "bestMan" && (
            <TuxIcon {...iconProps} title="Best Man" />
          )}
          <span>{name}</span>
        </span>
        <span className="Person-points">
          {peopleWithPoints[personId]
            ? (peopleWithPoints[personId].totalPoints || 0)
            : 0
          } points
        </span>
        {adminVisible && (
          <span className="Person-points-edit">
            <ButtonGroup
              options={pointsOptions.map(val => {
                const positive = val>0;
                return {
                  value: val,
                  label: ((positive ? '+' : '-') + Math.abs(val).toString()),
                }
              })}
              onChange={handlePointsChange}
              value={null}
              small
            />
          </span>
        )}
      </div>

    );

  };

};

Person.defaultProps = {
  peopleWithPoints: {},
  adminVisible: false,
};

Person.propTypes = {
  personId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  role: PropTypes.oneOf(config.roles),
  peopleWithPoints: PropTypes.object.isRequired,
  adminVisible: PropTypes.bool.isRequired,
  addPointsChange: PropTypes.func.isRequired,
};

export default Person;



// WEBPACK FOOTER //
// ./src/component/organisms/Person/component.js